import React, {useEffect, useState} from "react";
import {collection, query, getDocs, limit, where} from "@firebase/firestore";
import {Business, BusinessLocation, CurrentUser, UserCard, UserType} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";
import "./../../App.css"
import "./LocationPage.css"
import {httpsCallable} from "@firebase/functions";
import {db, functions} from "../../firebase/FirebaseProvider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCreditCard} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router";
import OfferList from "../../components/offer/OfferList";
import LocationMenu from "../../components/menu/location/LocationMenu";
import LocationRow from "../../components/location/LocationRow";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
  userCardsMap: Map<string, UserCard>,
}

function LocationPage(props: Props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [location, setLocation] = useState<BusinessLocation>();
  const [business, setBusiness] = useState<Business>();
  const [card, setCard] = useState<UserCard | undefined>();
  const [creatingCard, setCreatingCard] = useState<boolean>(false);

  const { id: locationId } = useParams();

  const fetchCard = async (business: string, navigateToCardPage: boolean) => {
    const cardCollection = query(
        collection(db, 'cards'),
        where("business", "==", business),
        where("user", "==", props.currentUser.id),
        where("status", "==","ACTIVE"),
        limit(1),
    );
    const cardSnapshot = await getDocs(cardCollection);
    cardSnapshot.forEach((doc) => {
      setCard(doc.data() as UserCard);
      setCreatingCard(false);
      if(navigateToCardPage) {
        navigate(`/card/${doc.data().id}`)
      }
    });
  };

  const createCard = async () => {
    if(!business) {
      return
    }
    setCreatingCard(true);
    const createCard = httpsCallable(functions, 'createCard');
    await createCard({
      business: business.id,
    }).then(() => {
      fetchCard(business.id, true);
    });
  };

  useEffect(() => {(async () => {
    const locationsCollection = query(
        collection(db, 'locations'),
        where("id", "==", locationId),
        limit(1),
    );
    const locationsSnapshot = await getDocs(locationsCollection);
    locationsSnapshot.forEach(async (doc) => {
      const businessLocation = doc.data() as BusinessLocation;
      setLocation(businessLocation);
      setBusiness(props.businessMap.get(businessLocation.business));
      await fetchCard(businessLocation.business, false);
      setLoading(false);
    });
  })();
  }, []);

  return (
      <>
        <AuthCheck />
        {(business && location) && <div>
            <LocationRow business={business} location={location} displayCard={false} distance={undefined}/>

           {props.currentUser.userType === UserType.CUSTOMER && <div className={"mt-3"}>
             {loading && <div>
                 <div className={"primary-button"}>
                     Loading...
                 </div>
             </div>}
             {!loading && !card && <div>
               {!creatingCard && <div className={"primary-button"} onClick={() => createCard()}>
                  <div className={"d-inline-block me-2"}>Create my card</div>
                  <FontAwesomeIcon icon={faCreditCard}/>
               </div>}
              {creatingCard && <div className={"primary-button"}>Creating...</div>}
             </div>}
             {card && <div>
                <div className={"primary-button"} onClick={() => navigate(`/card/${card.id}`)}>
                    <div className={"d-inline-block me-2"}>View my card</div>
                    <FontAwesomeIcon icon={faCreditCard}/>
                </div>
             </div>}
            </div>}

            <OfferList
                currentUser={props.currentUser}
                businessMap={props.businessMap}
                business={undefined}
                location={location.id}
                displayTitle={`${props.currentUser.userType === UserType.CUSTOMER ? 'Available' : ''} Offers`}
                defaultDisplayList={false}
                pointsCard={props.userCardsMap.get(location.business)}
            />

            <LocationMenu
                currentUser={props.currentUser}
                businessMap={props.businessMap}
                businessId={location.business}
                displayConfigButtons={false}
            />

            {business.configuration.eventsEnabled && <div className={"list-bg mt-3"}>
                <div className={"basic-box"}><b>Events</b></div>
                <div className={"basic-box colour-secondary mb-0"}>Nothing to display.</div>
            </div>}

        </div>}
      </>
  );
};

export default LocationPage;
